export default __webpack_public_path__ + "static/media/rating.3b24fc54.svg";